import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const uploadSurveyPicAction = createAsyncThunk(
    'upload-survey-pic',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/save-survey-pic`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const uploadSurveyPicSlice = createSlice({
    name: 'upload-survey-pic',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(uploadSurveyPicAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(uploadSurveyPicAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(uploadSurveyPicAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const uploadSurveyPicReducer = uploadSurveyPicSlice.reducer    